import JoinTaskService from 'services/task/subServices/joinTask/JoinTaskService';

export default {
	'services.joinTaskService': {
		class: JoinTaskService,
		deps: [{ $ref: 'services.taskStateService' }],
	},
};
